import { Component, Input, OnInit, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { DTypeForm, DTypeFormArray, DTypeFormEmbeddedCollectionField } from '@grupo-constant/next-dtype/form';
import { DTypeStatus, DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { DndDropEvent, DndModule } from 'ngx-drag-drop';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { DTypeService } from '../../dtype.service';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { DtypeItemComponent } from '../../dtype-item/dtype-item.component';
import { LocalizePipe } from '../../../pipes/standalone/localize.pipe';

@Component({
    selector: 'collection-field-component',
    templateUrl: './collection-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, MatButtonModule, LocalizePipe, TranslocoModule, MatIconModule, FormsModule,
        DndModule, forwardRef(() => DtypeItemComponent)]
})
export class DtypeCollectionFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormEmbeddedCollectionField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    constructor(private dtypeService: DTypeService) { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

    async addItem() {
        let newEmbeddedForm: DTypeForm;
        if (this.field.embeddedCollection.dType) { // El campo ya tiene el DType (más práctico)
            newEmbeddedForm = this.dtypeService.getDtypeFormFromDtype(this.field.embeddedCollection.dType, { isUpdate: this.isUpdate });
        } else {
            newEmbeddedForm = await this.dtypeService.getDtypeFormByUri({
                uri: this.field.uri, status: DTypeStatus.DESIGN, bindableOptions: true
            }, {}, {
                readonly: this.field.readonly,
                isUpdate: this.isUpdate
            });
        }

        if (newEmbeddedForm) {
            this.field.embeddedForms.push(newEmbeddedForm);
            (this.field.control as DTypeFormArray).push(newEmbeddedForm.control);
        }
    }

    removeItem(index: number) {
        this.field.embeddedForms.splice(index, 1);
        (this.field.control as DTypeFormArray).removeAt(index);
    }

    drop(event: DndDropEvent) {
        if (event.index <= this.field.embeddedForms.length) {
            const controls = (this.field.control as DTypeFormArray).controls;
            const currentIndex = this.field.control.value.findIndex(v => v.code === event.data.code);
            const form = this.field.embeddedForms[currentIndex];
            const control = controls[currentIndex];
            if (currentIndex > -1) {
                if (currentIndex < event.index) {
                    this.field.embeddedForms.splice(event.index, 0, form); // Add moved element to the new index
                    this.field.embeddedForms.splice(currentIndex, 1); // Remove moved element from the previous index

                    controls.splice(event.index, 0, control); // Add moved element to the new index
                    controls.splice(currentIndex, 1); // Remove moved element from the previous index
                } else if (currentIndex > event.index) {
                    this.field.embeddedForms.splice(currentIndex, 1); // Remove moved element from the previous index
                    this.field.embeddedForms.splice(event.index, 0, form); // Add moved element to the new index

                    controls.splice(currentIndex, 1); // Remove moved element from the previous index
                    controls.splice(event.index, 0, control); // Add moved element to the new index
                }
            }
        }
    }
}
